export enum CountryName {
  GreatBritain = 'Great Britain',
  Ireland = 'Ireland',
}
